import { render } from "./BankRecForm.vue?vue&type=template&id=ea8d0cbe&scoped=true"
import script from "./BankRecForm.vue?vue&type=script&lang=js"
export * from "./BankRecForm.vue?vue&type=script&lang=js"

import "./BankRecForm.vue?vue&type=style&index=0&id=ea8d0cbe&lang=css"
import "./BankRecForm.vue?vue&type=style&index=1&id=ea8d0cbe&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea8d0cbe"]])

export default __exports__